import _get from 'lodash/get';

const extraCostsApiParser = {
  ExtraCostsListParser: (res: any) => {
    if (!res) {
      return [];
    }

    return res?.data?.content?.map((itm: ExtraCostItem) => {
      const allocationType = _get(itm, 'allocationTypeDescription', '');
      const typeLower = String(allocationType || '').toLowerCase();
      const updatedAllocationType = typeLower === 'fifo' ? 'By Price' : allocationType;

      return {
        id: _get(itm, 'id', null),
        extraCostName: _get(itm, 'name', ''),
        allocationType: updatedAllocationType,
      };
    });
  },
};

export default extraCostsApiParser;

// --------------- Extra Cost-specific types and data ---------------

export interface ExtraCostItem {
  id: number;
  extraCostName: string;
  allocationType: string;
}

export interface ExtraCostsData {
  extraCosts: ExtraCostItem[];
}
